import { Skeleton, Stack } from "@mui/material";
import React from "react";

export const ItemSkeleton = ({ radius }: { radius?: number }) => {
  const borderRadius = (radius ?? 20) + "px";
  return (
    <Stack direction="column" gap="7px" p="10px">
      <Skeleton variant="rectangular" width={90} height={90} sx={{ borderRadius }} />
      <Skeleton variant="rectangular" width={90} height={30} sx={{ borderRadius }} />
      <Skeleton variant="rectangular" width={90} height={60} sx={{ borderRadius }} />
    </Stack>
  );
};
